import { useStore } from "vuex";
import { UserContext } from "./implementations/userContext.service";
import { useRouter } from 'vue-router'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()

  const userContext = new UserContext(
    nuxtApp,
    useStore(),
    router.push.bind(router) // Ensure the correct context for `this` in `router.push`
  );

  return {
    provide: {
      userContext: userContext,
    },
  };
});
